<div class="auto-sso-container">
  <div class="auto-sso-content">
    <!-- Logo -->
    <div class="logo-container mb-4 text-center">
      <img [src]="logoUrl" [alt]="brandName" class="brand-logo">
      <h3 class="brand-name mt-2">Mission Specialty Consults</h3>
    </div>

    <!-- Loading State -->
    <div *ngIf="!error" class="text-center">
      <div class="spinner-border text-primary mb-4" role="status" style="width: 3rem; height: 3rem;">
        <span class="visually-hidden">Loading...</span>
      </div>
      <h4 class="mb-3">Signing you in with Microsoft...</h4>
      <p class="text-muted">
        <small>You will be redirected automatically. Please wait...</small>
      </p>
    </div>

    <!-- Error State with Fallback Options -->
    <div *ngIf="error" class="text-center">
      <p class="session-message mb-4">
        Please sign in again, since your session has timed out.
      </p>

      <div class="d-grid gap-3">
        <!-- Manual SSO Retry Button -->
        <button
          type="button"
          class="btn btn-primary btn-lg d-flex align-items-center justify-content-center"
          (click)="manualSignIn()">
          <i class="fa fa-microsoft me-2"></i>
          Sign in with Microsoft
        </button>
      </div>

      <!-- Help Text -->
      <div class="mt-4">
        <p class="text-muted">
          <small>
            <i class="fa fa-info-circle me-1"></i>
            If you continue to experience issues, please contact your system administrator.
          </small>
        </p>
      </div>
    </div>

    <!-- Subtle Fallback Link (always visible) -->
    <div class="mt-5 text-center" *ngIf="!error">
      <p class="text-muted">
        <small>
          Not redirected automatically?
          <a href="javascript:void(0)" (click)="manualSignIn()" class="text-decoration-none">
            Click here to sign in with Microsoft
          </a>
        </small>
      </p>
    </div>
  </div>
</div>
